"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfigQuery = void 0;
const React = require("react");
const constants_1 = require("../../constants");
const app_1 = require("app");
const useConfigQuery = (initialQuery, setLastUserAction) => {
    const [query, setQuery] = React.useState(initialQuery || app_1.UrlService.GetQueryValueFromUrl('query') || '*');
    React.useEffect(() => {
        const onSearchQueryChange = (event) => {
            const customEvent = event;
            setQuery(customEvent.detail.query);
        };
        const onSearchQueryFromUrl = () => {
            const newQuery = app_1.UrlService.GetQueryValueFromUrl('query') || '*';
            if (newQuery === query)
                return;
            setLastUserAction({
                name: app_1.LastUserActionNameEnum.Query,
                value: newQuery,
            });
            setQuery(newQuery);
        };
        globalThis.addEventListener('popstate', onSearchQueryFromUrl);
        globalThis.addEventListener(constants_1.SEARCH_QUERY_CHANGE_EVENT, onSearchQueryChange);
        return () => {
            globalThis.removeEventListener('popstate', onSearchQueryFromUrl);
            globalThis.removeEventListener(constants_1.SEARCH_QUERY_CHANGE_EVENT, onSearchQueryChange);
        };
    }, []);
    return { query };
};
exports.useConfigQuery = useConfigQuery;
